import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import './HomeProductosMuestras.scss'
import { DobleGuion } from './DobleGuion'
import { connect } from 'react-redux'
import { selectCategoryExpositor, selectCategoryOutlet } from '../hooks/selectCategory'
import { setAllProducts, setProductsTable, resetFilters, pushFilters, setSelectedCategory, setPaginationState, showSpinner } from '../actions'
import { getPromosHome } from '../hooks/gets';
import { firstCharCapitalize } from '../utils/utils';
import { scrollBodyTop } from '../hooks/scrollPosition';
import { CategoryFilter } from '../filters/CategoryFilter';
import { PopupOneButton } from './PopupOneButton';
import { PreChangeBrandChosen } from '../hooks/config';
import _ from 'lodash';
const HomeProductosMuestras = (props) => {
    const navigate = useNavigate();
    const [promos, setPromos] = useState(null)
    const [showPopupPresupuestosPendientes, setShowPopupPresupuestosPendientes] = useState(false)

    useEffect(() => {
        getPromosHome().then(res => {
            setPromos(res.data)
        }).catch(err => {
            console.log('err', err)
        })
    }, [])

    const handleClickOutlet = () => {
      changeBrandGlobal().then((res)=>{
        if(res == true) {
          selectCategoryOutlet(props).then(res => {
            navigate('/outlet')
          }).catch(err => {
              console.log('err', err)
          })
        }
      })
    };

    const changeBrandGlobal = (marca = 'fansa') => {
      return new Promise(async (resolve)=>{
        let marcaCambiada = await PreChangeBrandChosen(marca, props.budget)
        if(!marcaCambiada){
          setShowPopupPresupuestosPendientes(true)
          resolve(false)
        }else{
          resolve(true)
        }
      })
    }

    const handleMenuClick = (promo) => {
        let url = ''
        if (promo.idcategory === '0') {
            url = '/expositores'
            changeBrandGlobal().then((res)=>{
              if(res == true) {
                selectCategoryExpositor(props).then(res => {
                    navigate(url);
                }).catch(err => {
                    console.log('err', err)
                })
                scrollBodyTop()
              }
            })
        } else {
            props.showSpinner(true)
            const categoryInfoAll = _.filter(props.categoriesAll, ['Name', promo.namecategory])[0]
            props.setPaginationState(1)
            props.setProductsTable('allProducts')
            const categoryFilter = new CategoryFilter(categoryInfoAll.Name)
            props.setSelectedCategory({
                categoryId: categoryInfoAll.ID,
                subtitle: categoryInfoAll.Name,
                img: categoryInfoAll.ImgBanner,
                selectedCollection: ''
            })
            props.resetFilters()
            props.pushFilters(categoryFilter)
            url = '/categoria/' + categoryInfoAll.ID
            scrollBodyTop()
            props.showSpinner(false)
            navigate(url);
        }
    }

    return (
        <div className="productos-muestras">
            {showPopupPresupuestosPendientes &&
                <PopupOneButton title="¡Presupuestos pendientes!" text="Tienes presupuestos pendientes, para cambiar de marca debes guardar o eliminar los presupuestos." textButton="Aceptar" onClick={() => setShowPopupPresupuestosPendientes(false)} />
            }
            {promos !== null &&
                <div className="productos-muestras-content">
                    <div className="left-container">
                        <div className="titulo"><p>{firstCharCapitalize(promos[1].namecategory)}</p></div>
                        <div className="subtitulo"><p>{promos[1].text}</p></div>
                        <div className="imagen"><img src={promos[1].img} onError={(e) => {
                            e.target.onerror = null
                            e.target.src = '/static/img/no-imagen-fansa.png'
                        }} alt="" /></div>
                        <div className="btn" onClick={() => handleMenuClick(promos[1])}><p>Ver productos</p></div>
                    </div>
                    <div className="right-container">
                        <div className="l1">
                            <div className="l1-left-container">
                                <div className="img"><img src="/static/img/hoja.png" alt="" /></div>
                                <div className="porcentaje"><p>{promos[0].text}</p></div>
                                <div className="text"><DobleGuion /><p>OFF</p><DobleGuion /></div>
                                <div className="btn" onClick={handleClickOutlet}><p>Ver productos</p></div>
                            </div>
                            <div className="l1-right-container">
                                <div className="left">
                                    <div className="titulo-subtitulo">
                                        <div className="titulo"><p>{firstCharCapitalize(promos[2].namecategory)}</p></div>
                                        <div className="subtitulo"><p>{promos[2].text}</p></div>
                                    </div>
                                    <div className="btn" onClick={() => handleMenuClick(promos[2])}><p>Ver productos</p></div>
                                </div>
                                <div className="right">
                                    <div className="img"><img src={promos[2].img} onError={(e) => {
                                        e.target.onerror = null
                                        e.target.src = '/static/img/no-imagen-fansa.png'
                                    }} alt="" /></div>
                                </div>
                            </div>
                        </div>
                        <div className="l2">
                            <div className="left">
                                <div className="titulo-subtitulo">
                                    <div className="titulo"><p>{firstCharCapitalize(promos[3].namecategory)}</p></div>
                                    <div className="subtitulo"><p>{promos[3].text}</p></div>
                                </div>
                                <div className="btn" onClick={() => handleMenuClick(promos[3])}><p>Ver productos</p></div>
                            </div>
                            <div className="right">
                                <div className="img">
                                    <img src={promos[3].img} onError={(e) => {
                                        e.target.onerror = null
                                        e.target.src = '/static/img/no-imagen-fansa.png'
                                    }} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

const mapStateToProps = state => state

const mapDispatchToProps = {
    setAllProducts,
    setProductsTable,
    resetFilters,
    pushFilters,
    setPaginationState,
    setSelectedCategory,
    showSpinner,
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeProductosMuestras)